import { Link } from 'react-router-dom';
import { LogOut, Search, Menu, ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  onSearchClick?: () => void;
  onMenuClick?: () => void;
}

export default function SiteHeader({ onSearchClick, onMenuClick }: Props) {
  const { user, logout, isStaff } = useAuth();
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        {onMenuClick && (
          <button
            type="button"
            className="site-header__menu"
            aria-label="Toggle navigation"
            onClick={onMenuClick}
          >
            <Menu className="h-4 w-4" />
          </button>
        )}
        <Link to="/" className="site-header__brand">
          <span className="wordmark">Henoyo</span>
          <span className="site-header__tag">Schema Reference</span>
        </Link>
        <div className="site-header__right">
          {onSearchClick && (
            <button
              type="button"
              className="site-header__search"
              aria-label="Open search"
              onClick={onSearchClick}
            >
              <Search className="h-4 w-4" />
              <span className="site-header__search-label">Search docs…</span>
              <kbd className="site-header__kbd">{isMac ? '⌘K' : 'Ctrl K'}</kbd>
            </button>
          )}
          {isStaff === true && (
            <Link to="/admin" className="site-header__admin" aria-label="Open admin">
              <ShieldCheck className="h-4 w-4" />
              <span>Admin</span>
            </Link>
          )}
          {user && (
            <button
              onClick={logout}
              className="site-header__logout"
              aria-label="Sign out"
            >
              <LogOut className="h-4 w-4" />
              <span>Logout</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
